import types from './types';

function simulatorReducer(state, action) {
  switch(action.type) {
    case types.ADD_IDENTITY_PHOTO_FILE:
      return {...state, identityPhoto: [...state.identityPhoto, action.file[0]]}
    case types.REMOVE_IDENTITY_PHOTO_FILE:
      return {...state, identityPhoto: action.file}
    case types.SET_IDENTIFICATION_TYPE:
      return {...state, registration: {...state.registration, tipoIdentificacion: action.tipoIdentificacion}}
    case types.SET_GENDER:
      return {...state, registration: {...state.registration, genero: action.genero}}
    case types.SET_REGISTRATION_DATA:
      return {...state, registration: action.registration }
    case types.SET_CLIENT_PHOTO_FILE:
      return {...state, clientPhoto: [...state.clientPhoto, action.file[0]]}
    case types.REMOVE_CLIENT_PHOTO_FILE:
      return {...state, clientPhoto: action.file}
    case types.SET_SELECTED_STATE:
      return {...state, aditionalData: {...state.aditionalData, state: action.state }}
    case types.SET_SELECTED_CITY:
      return {...state, aditionalData: {...state.aditionalData, city: action.city }}
    case types.SET_ADITIONAL_DATA:
      return {...state, aditionalData: action.data }
    case types.SET_SIMULATION_DATA:
      return {...state, simulacion: action.data }
    case types.SET_CREDIT_ID:
      return {...state, idCliente: action.data.idCliente, idCredito: action.data.idCredito }
    case types.SET_CREDIT:
      return {...state, credit: action.credit }
    case types.SET_SOLICITATION_DATA:
        return {...state, ...action.data }
    case types.SET_EXISTING_CLIENT_DATA:
        return {...state, clienteFull: {...state.client, ...action.data} }
    default:
      return state;
  }
}

export default simulatorReducer;
